import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { PDF_EXPORT_QUERY_PARAM_EXPORT_TARGET } from 'common/constants/pdfExport';

// In export mode the WidgetDrawer relay publishes a page's notes/document
// references keyed to whichever export target is currently being captured. A
// route that renders several capture targets must only relay its widgets while
// one of its own targets is the active one, otherwise the notes get stamped onto
// the route's other capture targets too. Pass an array when the same relay should
// feed more than one exported page. Outside export mode widgets always relay.
export const useExportWidgetRelay = (target: string | string[], isExportMode: boolean) => {
  const location = useLocation();

  const currentExportTarget = useMemo(
    () => (isExportMode ? new URLSearchParams(location.search).get(PDF_EXPORT_QUERY_PARAM_EXPORT_TARGET) : null),
    [isExportMode, location.search]
  );

  const targets = Array.isArray(target) ? target : [target];
  const shouldRelayExportWidgets = !isExportMode || targets.includes(currentExportTarget ?? '');

  return { currentExportTarget, shouldRelayExportWidgets };
};
